<mat-form-field class="svc-mat-no-subscript svc-mat-dense w-full">
	<input [formControl]="formControl" matInput [placeholder]="placeholder | transloco" type="search" (keydown.enter)="onValueChanged({ force: true })" [id]="inputId"/>
	<button mat-icon-button matSuffix (click)="onValueChanged({ force: true })" class="text-default">
		<mat-icon class="icon-size-3 text-primary" svgIcon="fontawesome_solid:magnifying-glass"></mat-icon>
	</button>
</mat-form-field>
